import Utils from "../../services/Utils.js";
import { getMatch } from "../../js/api/singleMatch.js";
import {
  getSingleColumnModule,
  getInsideSingleColumn,
} from "../templates/singleColumnModule.js";
import { _t } from "../../services/TranslationService.js";
import { getUserGroup } from "../../services/UserGroup.js";
var gameId = 0;
let groupMatchHomeName = "";
let groupMatchAwayName = "";
let matchSportName = "";
let matchCountryName = "";
let Match = {
  render: async () => {
    let request = Utils.parseRequestURL();
    if (request && request.query && request.query.today == 1) {
      localStorage.setItem("today", true);
    }
    let groupMatches = await getMatch(request.id);
    gameId = request.id;

    matchSportName = groupMatches[0][0].sport_name;
    matchCountryName = groupMatches[0][0].country_name;
    let groupMatchView = "";
    let matchView = "";
    let scrollMeContent = "";
    let groupMatchDate = "";

    const isSpecial447 = groupMatches.every((group) =>
      group.every((match) => match.country_id == 447),
    );

    let acc = groupMatches.map(function (item) {
      return {
        mainCategoryID: item[0].mainCategoryID,
        market_id: item[0].mainCategoryID ? -1 : item[0].market_id,
        mainCategory: item[0].mainCategory,
      };
    });

    const uniqueCategories = [];

    $.each(acc, function (i, el) {
      const res = uniqueCategories.find(
        (a) =>
          a.mainCategoryID == el.mainCategoryID && a.market_id == el.market_id,
      );
      if (!res) uniqueCategories.push(el);
    });

    uniqueCategories.forEach((category) => {
      console.log(uniqueCategories);
      let activeClass = "";
      if (scrollMeContent == "") activeClass = "active";
      const categoryLabel =
        isSpecial447 && category.mainCategory.toLowerCase().includes("kryesore")
          ? "Special"
          : category.mainCategory;

      scrollMeContent += `<a class="singleMatchCatBtn ${activeClass}" data-target="${category.mainCategoryID}-module">${_t(categoryLabel)}</a>`;
      matchView = "";

      const a = groupMatches.filter(
        (a) => a[0].mainCategoryID == category.mainCategoryID,
      );

      groupMatchView =
        groupMatchView +
        `<div class="singleMatchBetModule ${activeClass}" data-content="${category.mainCategoryID}-module">`;

      a.forEach((groupMatch) => {
        groupMatchHomeName = `${groupMatch[0].home_team}`;
        groupMatchAwayName = `${groupMatch[0].away_team}`;
        groupMatchDate = `${groupMatch[0].game_date}`;

        var howtoproceed = 0;
        switch (groupMatch[0].market.toLowerCase()) {
          case "draw no bet":
            howtoproceed = 1;
            break;
        }
        var jsondata;

        const hasSpecialValue =
          groupMatch[0].special_value &&
          groupMatch[0].special_value != "" &&
          groupMatch[0].type_of_column;

        let classDescription = "";

        if (isSpecial447) {
          classDescription = "oneColumn";
        } else {
          switch (Number(groupMatch[0].nr_of_columns)) {
            case 1:
              classDescription = "oneColumn";
              break;
            case 2:
              classDescription = "twoColumns";
              break;
            case 3:
              classDescription = "threeColumns";
              break;
            case 4:
              classDescription = "threeColumns";
              break;
          }
        }

        if (!isSpecial447 && groupMatch[0].type_of_column) {
          matchView += `<div class="singleHeaderHolderLabel">`;

          if (hasSpecialValue) {
            matchView += `<div class="singleHeaderLabel ${classDescription}"></div>`;
          }

          if (groupMatch[0].type_of_column == 1) {
            matchView += `<div class="singleHeaderLabel ${classDescription}">${_t("Lart")}</div>`;
            matchView += `<div class="singleHeaderLabel ${classDescription}">${_t("Poshte")}</div>`;
          }

          if (groupMatch[0].type_of_column == 2) {
            matchView += `<div class="singleHeaderLabel ${classDescription}">${_t("Lart")}</div>`;
            matchView += `<div class="singleHeaderLabel ${classDescription}">X</div>`;
            matchView += `<div class="singleHeaderLabel ${classDescription}">${_t("Poshte")}</div>`;
          }

          if (groupMatch[0].type_of_column == 3) {
            matchView += `<div class="singleHeaderLabel ${classDescription}">${groupMatchHomeName}</div>`;
            matchView += `<div class="singleHeaderLabel ${classDescription}">${groupMatchAwayName}</div>`;
          }

          if (groupMatch[0].type_of_column == 4) {
            matchView += `<div class="singleHeaderLabel ${classDescription}">${groupMatchHomeName}</div>`;
            matchView += `<div class="singleHeaderLabel ${classDescription}">X</div>`;
            matchView += `<div class="singleHeaderLabel ${classDescription}">${groupMatchAwayName}</div>`;
          }

          matchView += `</div>`;
        }

        let currentSpecialValue = "";

        groupMatch.forEach((match) => {
          if (hasSpecialValue && match.special_value != currentSpecialValue) {
            matchView =
              matchView +
              `<div class="singleColumnModule labelBtn ${classDescription}">
                         <span>${match.special_value}</span>
                       </div>`;

            currentSpecialValue = match.special_value;
          }

          jsondata = JSON.stringify(match);

          matchView =
            matchView +
            getSingleColumnModule(
              match,
              request,
              classDescription,
              hasSpecialValue,
            );
        });

        let columnClass = "";
        switch (groupMatch[0].type_of_column == 4) {
          case 4:
            columnClass = "fourColumns";
            break;
          default:
            columnClass = "";
            break;
        }

        groupMatchView =
          groupMatchView +
          `<div class="singleMatchBetModuleGroup ${columnClass}"  id="${groupMatch[0].market_id}">
                 <div class="singleMatchBetModuleGroupHeader">
                   <span class="titleMarketSearch">${_t(groupMatch[0].market)}</span>
                 </div>
                 <div class="singleMatchBetModuleGroupContent" id="${groupMatch[0].market_id}-content">
                    ${matchView}
                 </div>
               </div>`;
        matchView = "";
      });

      groupMatchView = groupMatchView + `</div>`;

      // if (howtoproceed == 1) {
      //   groupMatchView =
      //     groupMatchView +
      //     `<div class="singleMatchBetModuleGroup twoColumn" id="${groupMatch[0].market_id}">
      //            <div class="singleMatchBetModuleGroupHeader">
      //              <span>${groupMatch[0].market}</span>
      //            </div>
      //            <div class="singleMatchBetModuleGroupContent" id="${groupMatch[0].market_id}-content">
      //               ${matchView}
      //            </div>
      //          </div>`;
      // } else {
      //   groupMatchView =
      //     groupMatchView +
      //     `<div class="singleMatchBetModuleGroup" id="${groupMatch[0].market_id}">
      //            <div class="singleMatchBetModuleGroupHeader">
      //              <span>${groupMatch[0].market}</span>
      //            </div>
      //            <div class="singleMatchBetModuleGroupContent">
      //               ${matchView}
      //            </div>
      //          </div>`;
      // }
    });

    console.log(groupMatchHomeName, "console me thissss !!!!");
    // let posts = await getPostsList()
    let view = /*html*/ `
            <a class="backBtn prematchArrow  m-t-6">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"></path></svg>
               </a>
            <div class="singleMatchTitle prematchLabelArrow m-t-6">
            <div class="singleMatchScrolLMeName">
               <div class="singleCategoryTitle">
                 <a>${matchSportName} / ${matchCountryName} </a>
               </div>
               <span class="matchVersusName">/ ${groupMatchHomeName} vs ${groupMatchAwayName}</span>
               <span>${groupMatchDate.split(":")[0]}:${
                 groupMatchDate.split(":")[1]
               }</span></div>
             </div>
             <div class="matchHero" style="border-top: 2px solid var(--InTitleLightColor);">
                <div class="matchHeroOverlay"></div>

                <div class="matchHeroContent">
                    <div class="centereized">
                        <div class="centereized-left">
                            <div class="matchHeroSide left">
                                <span>${groupMatchHomeName}</span>
                            </div>

                            <div class="matchHeroCenter">
                                <span>VS</span>
                            </div>

                            <div class="matchHeroSide right">
                                <span>${groupMatchAwayName}</span>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
             <div class="singleMatchCatButtons">
               <div class="scrollMe" id="scrollMeContent">
                 ${scrollMeContent}
              </div>
             </div>
             <span class="showDateMobile">${groupMatchDate.split(":")[0]}:${groupMatchDate.split(":")[1]}</span></div>
             <div class="singleMatchSearchMarkets matchSingleMarketInput" hidden>
                <input type="text" id="searchMarketsId" placeholder="${_t("Kerko")}">
            </div>
             <div id="${gameId}-content">
               ${groupMatchView}
             </div>

       `;
    return view;
  },
  after_render: async (socket) => {
    function delay(callback, ms) {
      var timer = 0;
      return function () {
        var context = this,
          args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          callback.apply(context, args);
        }, ms || 0);
      };
    }

    $("body").on(
      "keyup",
      "#searchMarketsId",
      delay(async function (e) {
        let marketMatchText = $("#searchMarketsId").val().toLowerCase();
        console.log(marketMatchText);

        if (marketMatchText == "") {
          $(".removeItem").removeClass("removeItem");
        } else {
          $("body .titleMarketSearch").each(function (i, item) {
            let valueOfMarket = $(item).text().toLowerCase();
            console.log(item, ";item");
            console.log(valueOfMarket, "itemi i kerkuarrr");
            if (!valueOfMarket.includes(marketMatchText)) {
              $(item)
                .parent(".singleMatchBetModuleGroupHeader")
                .parent(".contentMarketNull")
                .parent(".singleMatchBetModuleGroup ")
                .addClass("removeItem");
              $(item)
                .parent(".singleMatchBetModuleGroupHeader")
                .parent(".singleMatchBetModuleGroup ")
                .addClass("removeItem");
            } else {
              $(item)
                .parent(".singleMatchBetModuleGroupHeader")
                .parent(".contentMarketNull")
                .parent(".singleMatchBetModuleGroup ")
                .removeClass("removeItem");
              $(item)
                .parent(".singleMatchBetModuleGroupHeader")
                .parent(".singleMatchBetModuleGroup ")
                .removeClass("removeItem");
            }
          });
        }
      }, 300),
    );
    //socket.emit('connectToRoom', {room: gameId});
    const event = new CustomEvent("addToRoom", {
      detail: gameId,
    });
    window.dispatchEvent(event);
    $("body .singleMatchCatBtn")
      .unbind("click")
      .on("click", function (e) {
        $("body .singleMatchCatBtn").removeClass("active");
        $("body .singleMatchBetModule").removeClass("active");
        $(e.currentTarget).addClass("active");
        let putTriggerContent = $(e.currentTarget).attr("data-target");
        $("body .singleMatchBetModule").each(function (i, item) {
          if ($(item).attr("data-content") == putTriggerContent) {
            $(item).addClass("active");
          }
        });
      });

    $("body .singleMatchBetModuleGroupContent").each(function (i, item) {
      if ($(item).children(".bettingBtn").length == 2) {
        $(item).addClass("column-2");
      } else if (
        $(item).find(".singleHeaderHolderLabel").children(".singleHeaderLabel")
          .length === 4
      ) {
        $(item).addClass("column-4");
        $(item).addClass("fourColumns");
      }
    });

    socket.on("new-coefs", (res) => {
      if (res.game_id == gameId) {
        const userGroup = getUserGroup();
        res.coefs.forEach((data) => {
          data = transformSingleCoef(data, userGroup);
          const market = document.getElementById(data.market_id);
          const marketContent = document.getElementById(
            data.market_id + "-content",
          );
          const newSingleCoefTemplate = getSingleColumnModule(
            {
              home_team: groupMatchHomeName,
              away_team: groupMatchAwayName,
              market_option: data.market_option_name,
              market: data.market_id,
              odd: data.odd,
              id: data.coef_id,
            },
            { id: data.game_id },
          );

          if (!market) {
            let mainContainer = document.getElementById(`${gameId}-content`);
            if (mainContainer) {
              mainContainer.innerHTML =
                mainContainer.innerHTML +
                `<div class="singleMatchBetModuleGroup" id=${data.market_id}>
              <div class="singleMatchBetModuleGroupHeader">
                <span class="titleMarketSearch">${_t(data.market_name)}</span>
              </div>
              <div class="singleMatchBetModuleGroupContent">
                 ${newSingleCoefTemplate}
              </div>
            </div>`;
            }
          } else {
            var div = document.getElementsByClassName(data.coef_id)[0];
            if (div) {
              div.innerHTML = getInsideSingleColumn(
                data.market_option_name,
                data.odd,
              );
            } else {
              marketContent.innerHTML += newSingleCoefTemplate;
            }
          }
        });
        updateMatch();
      }
    });

    if ($(window).width() <= 600) {
      let scrollWidth = 0;
      let scrollMeWidth = 0;

      scrollMeWidth += $("body .singleCategoryTitle").width();
      scrollMeWidth += $("body .matchVersusName").width();

      $(".singleMatchScrolLMeName").width(scrollMeWidth + 50);

      $("body .singleMatchCatBtn").each(function () {
        scrollWidth += $(this).width() + 21;
      });
      $("body .scrollMe").css({
        width: scrollWidth + "px",
      });
    }
  },
  on_unload: async (socket) => {
    //socket.emit('leaveRoom', {room: gameId});
    const event = new CustomEvent("leaveRoom", {
      detail: gameId,
    });
    window.dispatchEvent(event);
  },
};

export default Match;
